<template>
  <a-select
    style="min-width: 200px"
    :value="currentGroup.id"
    @change="handleChange"
  >
    <a-select-option
      v-for="o in allGroupsList" :key="o.id"
      :value="o.id"
    >
      {{o.name}}
    </a-select-option>
  </a-select>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'GroupsListSelect',
  // props: ['allList'],
  methods: {
    handleChange (id) {
      this.$store.commit('setCurrentGroup', this.getGroup(id))

      this.$store.dispatch('getAllMembers', id)
      // this.$store.commit('setCurrentGroupData', this.getGroup(id))
    },
  },
  computed: {
    ...mapState({
      allGroupsList: state => state.allGroupsList,
      // allIdsData: state => state.allIdsData,
      // currentGroupId: state => state.currentGroupId,
      currentGroup: state => state.currentGroup
    }),
    ...mapGetters([
      'getGroup'
    ]),
    defaultValued() {
      // console.log(this.allList.length == 0)
      // console.log(this.allListsRaw)
      // let defaultValue = this.allList[0].name
      // return defaultValue
    }
  },
}
</script>